module.exports = new __parcel__URL__("type-error.f8bb5761.svg").toString();